/**
 * Created by Sasha on 7/25/2018.
 */
import moment from 'moment';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Observable , BehaviorSubject} from 'rxjs';
import {AppConfig} from '../../app.config';
@Injectable()
export class CommunicationService{
  communications: any[];
  // onCommunicationChanged: BehaviorSubject<any> = new BehaviorSubject({});

  constructor (private http: HttpClient , private api: AppConfig) {

  }

  // /**
  //  * Resolve
  //  * @param {ActivatedRouteSnapshot} route
  //  * @param {RouterStateSnapshot} state
  //  * @returns {Observable<any> | Promise<any> | any}
  //  */
  // resolve (route: ActivatedRouteSnapshot , state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
  //
  //   return new Promise((resolve , reject) => {
  //
  //     Promise.all([
  //       this.getTags()
  //     ]).then(
  //       () => {
  //         resolve();
  //       } ,
  //       reject
  //     );
  //   });
  // }
  //
  // getTags () {
  //   return new Promise((resolve , reject) => {
  //     this.http.get(this.api.baseUrl + '/communicationData/communications' , this.api.jsonTokenHeaders)
  //       .subscribe((response: any) => {
  //         response.map((item) => {
  //           if (item.data) {
  //             item.data = JSON.parse(item.data);
  //           }
  //           if (item.type === 'sms') {
  //             item.dataForShow = item.data['numbers'].split(',');
  //           }
  //           if (item.type === 'mail') {
  //             item.dataForShow = item.data['mails'].split(',');
  //           }
  //           if (item.type === 'serial') {
  //             item.dataForShow = item.data['userInfo'];
  //           }
  //         });
  //
  //         this.communications = response;
  //         this.onCommunicationChanged.next(this.communications);
  //         resolve(response);
  //       } , reject);
  //   });
  // }

  getCommunications(type, page, perPage, sortBy, sortDirection, search) {
    return this.http.get(this.api.baseUrl + '/communicationData/getCommunications?type=' + type + '&page=' + page + '&perPage=' + perPage +
      '&sortBy=' + sortBy + '&sortDirection=' + sortDirection + '&search=' + search, this.api.jsonTokenHeaders);
  }

  getWhatsAppHistory(page, perPage, sortBy, sortDirection) {
      return this.http.get(this.api.baseUrl + '/communication/whatsapp?page=' + page + '&perPage=' + perPage +
        '&sortBy=' + sortBy + '&sortDirection=' + sortDirection,
        this.api.jsonTokenHeaders);
  }

  getEmailEditorData() {
    return this.http.get(this.api.baseUrl + '/emailEditor/allEmailData',
      this.api.jsonTokenHeaders);
  }

  getAdminCommunication(page, perPage, search) {
    return this.http.get(this.api.baseUrl + '/communication/getAdminEmails?page=' + page + '&perPage=' + perPage +
      '&search=' + search, this.api.jsonTokenHeaders);
  }

  getAdminNewEmailsCount() {
      return this.http.get(this.api.baseUrl + '/communication/getAdminNewEmailsCount', this.api.jsonTokenHeaders);
  }

  readEmail(id) {
    return this.http.get(this.api.baseUrl + '/communication/readByAdmin?id=' + id, this.api.jsonTokenHeaders);
  }

  deleteEmail(id) {
    return this.http.get(this.api.baseUrl + '/communication/deleteByAdmin?id=' + id, this.api.jsonTokenHeaders);
  }

  deleteMsg(id) {
    return this.http.get(this.api.baseUrl + '/communicationData/deleteMsg?id=' + id, this.api.jsonTokenHeaders);
  }
  saveEmailEditorData(data) {
    return this.http.post(this.api.baseUrl + '/emailEditor/saveEmailData', data, this.api.jsonTokenHeaders);
  }

  inviteQrCodes(data) {
    return this.http.post(this.api.baseUrl + '/communication/inviteQrCodes', data, this.api.jsonTokenHeaders);
  }

  registrationQrCode() {
    return this.http.get(this.api.baseUrl + '/communication/registrationQrCode', this.api.jsonTokenHeaders);
  }
}

